import FHPL from '@public/images/fhpl.png';
import {
    SingleCashlessCardWrapper,
    LogoWrapper,
    AckoLogo,
    LinkedAssetWrapper,
    PolicyOwnerText,
    PolicyDetailsWrapper,
    PolicyNumberWrapper,
    PolicyNumberTitle,
    PolicyNumberText,
} from './styles';
import Image from 'next/image';
import { AckoLogoConfig } from '@utils/constants';

interface IProps {
    name: string;
    uhid: string;
    policyNumber: string;
    relationship: string;
}

function cardDetails({ name, uhid, policyNumber, relationship }: IProps) {
    return (
        <SingleCashlessCardWrapper>
            <LogoWrapper>
                <AckoLogo>
                    <Image
                        src={AckoLogoConfig.gradient}
                        alt={''}
                        width={50}
                        height={16}
                    />
                </AckoLogo>
                <LinkedAssetWrapper>
                    <img
                        src={FHPL}
                        alt={''}
                        style={{ width: '34px', height: '16px' }}
                    />
                </LinkedAssetWrapper>
            </LogoWrapper>
            <PolicyOwnerText style={{ marginTop: '10px' }}>
                {name}
            </PolicyOwnerText>
            <PolicyNumberWrapper style={{ marginTop: '10px' }}>
                <PolicyNumberText>UHID: {uhid}</PolicyNumberText>
            </PolicyNumberWrapper>
            <PolicyDetailsWrapper>
                <PolicyNumberWrapper>
                    <PolicyNumberTitle>Policy number</PolicyNumberTitle>
                    <PolicyNumberText>{policyNumber}</PolicyNumberText>
                </PolicyNumberWrapper>
                <PolicyNumberWrapper>
                    <PolicyNumberTitle>Relationship</PolicyNumberTitle>
                    <PolicyNumberText>{relationship}</PolicyNumberText>
                </PolicyNumberWrapper>
            </PolicyDetailsWrapper>
        </SingleCashlessCardWrapper>
    );
}

export default cardDetails;
